export default __webpack_public_path__ + "static/media/comptes_collaborateurs.922b8877.svg";